import { NullTemplateVisitor } from '@angular/compiler';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Component({
  selector: 'app-date-details',
  templateUrl: './date-details.component.html',
  styleUrls: ['./date-details.component.css']
})
export class DateDetailsComponent implements OnInit {
  @Input() approvalData: any;
  @Input() requestType: number;
  @Input() maxValidityDate: any;
  @Input() allDates: any;
  @Input() isBulkApproval: boolean;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  constructor(public activeModal: NgbActiveModal,) { }
  date = new Date();

  ngOnInit() {
    if (this.isBulkApproval) {
        this.allDates.LicenseValidity ? moment(this.allDates.LicenseValidity).toDate() : '';
        this.allDates.ECPolicyValidity ? moment(this.allDates.ECPolicyValidity).toDate() : '';
        this.allDates.WorkOrderValidity ? moment(this.allDates.WorkOrderValidity).toDate() : '';
        this.approvalData.XrayValidityDate ? moment(this.approvalData.XrayValidityDate).toDate() : '';
        this.approvalData.EyeTestingValidityDate ? moment(this.approvalData.EyeTestingValidityDate).toDate() : '';
    } else {
      this.approvalData.POValidityDate = this.approvalData.POValidityDate ? moment(this.approvalData.POValidityDate).toDate() : null;
      this.approvalData.LicenseValidityDate = this.approvalData.LicenseValidityDate ? moment(this.approvalData.LicenseValidityDate).toDate() : null;
      this.approvalData.ECPolicyValidityDate = this.approvalData.ECPolicyValidityDate ? moment(this.approvalData.ECPolicyValidityDate).toDate() : null;
      this.approvalData.XrayValidityDate = this.approvalData.XrayValidityDate ? moment(this.approvalData.XrayValidityDate).toDate() : null;
      this.approvalData.EyeTestingValidityDate = this.approvalData.EyeTestingValidityDate ? moment(this.approvalData.EyeTestingValidityDate).toDate() : null;
    }
  }

  filterData() {
    this.activeModal.close();
  }
}